import merge from 'lodash.merge';
import { forwardRef, Ref } from 'react';
import { MotionBox, MotionBoxProps } from './Motion';

const DEFAULT_INITIAL = { opacity: 0 };
const DEFAULT_ANIMATE = {
    opacity: 1,
    transition: {
        duration: 0.5,
    },
};

export type FadeInBoxProps = MotionBoxProps & { fadeOut?: boolean };

const FadeInBoxInner = (
    {
        initial,
        animate,
        display = 'flex',
        flexDirection = 'column',
        delay = 0,
        fadeOut = false,
        ...props
    }: FadeInBoxProps,
    ref: Ref<HTMLDivElement>
) => {
    let combinedInitial: MotionBoxProps['initial'] = DEFAULT_INITIAL;
    if (initial) {
        combinedInitial =
            typeof initial === 'object' && !Array.isArray(initial)
                ? // If passed-in `initial` can be merged with default, do so
                  merge({}, DEFAULT_INITIAL, initial)
                : // Otherwise, simply overwrite
                  initial;
    }
    let combinedAnimate: MotionBoxProps['animate'] = merge(
        {},
        DEFAULT_ANIMATE,
        { transition: { delay } }
    );
    if (animate) {
        combinedAnimate =
            typeof animate === 'object' && !Array.isArray(animate)
                ? // If passed-in `animate` can be merged with default, do so
                  merge({}, DEFAULT_INITIAL, animate)
                : // Otherwise, simply overwrite
                  animate;
    }

    return (
        <MotionBox
            {...props}
            ref={ref}
            display={display}
            flexDirection={flexDirection}
            initial={combinedInitial}
            animate={combinedAnimate}
            {...(fadeOut && {
                exit: {
                    opacity: 0,
                    transition: { duration: 0.5 },
                },
            })}
        />
    );
};

const FadeInBox = forwardRef<HTMLDivElement, FadeInBoxProps>(FadeInBoxInner);
export default FadeInBox;
